module.exports = __webpack_public_path__ + "static/img/service-user-head.28cfdc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service-user-head.jpg
// module id = kFli
// module chunks = 10